import { defineComponent as _defineComponent } from 'vue'
import device from '@@/bits/device'
import { useSurfaceStore } from '@@/pinia/surface'
import { useSurfacePermissionsStore } from '@@/pinia/surface_permissions'
import { useSurfacePostsDragAndDropStore } from '@@/pinia/surface_posts_drag_and_drop'
import { useSurfaceWishArrangementStore } from '@@/pinia/surface_wish_arrangement'
import type { Id } from '@@/types'
import SurfaceHeader from '@@/vuecomponents/SurfaceHeader.vue'
import { useDoubleClickToPost } from '@@/vuecomposables/surface_double_click_to_post'
import { GroupByTypes } from '@padlet/arvo'
import { storeToRefs } from 'pinia'
import { defineAsyncComponent } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurfaceContainerStream',
  props: {
    reactionIdsByPostId: { default: () => ({}) },
    commentIdsByPostId: { default: () => ({}) }
  },
  emits: ['scroll'],
  setup(__props: any) {

const SurfaceAddSectionButton = defineAsyncComponent(() => import('vuecomponents/SurfaceAddSectionButton.vue'))
const SurfacePostsStream = defineAsyncComponent(() => import('vuecomponents/SurfacePostsStream.vue'))





const { xHeader, backgroundLuminance, isReadOnly, isPostSizeStandard, isPostSizeWide, isFrozen } = storeToRefs(
  useSurfaceStore(),
)
const { canIModerate } = storeToRefs(useSurfacePermissionsStore())
const { wishGroupBy } = storeToRefs(useSurfaceWishArrangementStore())
const { isDraggingPostInNonManuallySortedWall } = storeToRefs(useSurfacePostsDragAndDropStore())
if (!device.mobile) useDoubleClickToPost()

return { __sfc: true,SurfaceAddSectionButton, SurfacePostsStream, xHeader, backgroundLuminance, isReadOnly, isPostSizeStandard, isPostSizeWide, isFrozen, canIModerate, wishGroupBy, isDraggingPostInNonManuallySortedWall, SurfaceHeader, GroupByTypes }
}

})